import { gql } from "@apollo/client";
import Fragments from "features/quote/fragments";

export const SET_SELECTED_PRODUCT = gql`
  mutation setSelectedProduct($quoteId: Int!, $quoteProductId: Int!) {
    setSelectedProduct(quoteId: $quoteId, quoteProductId: $quoteProductId)
  }
`;

export const SET_DATA_COMPLETION = gql`
  mutation setDataCompletion($quoteId: Int!) {
    setDataCompletion(quoteId: $quoteId) {
      ...quote
    }
  }
  ${Fragments.quote}
`;

export const SAVE_PRODUCT = gql`
  mutation saveProduct($input: ProductInput!) {
    saveProduct(input: $input) {
      ...quoteProduct
      firstInstallmentDate
      cellParamsConfigurations {
        monthDate
        params {
          scheduleTypeCellParamId
          scheduleTypeCellParamCode
          value
        }
      }
      quoteProductServices {
        id
        duration
        financedYN
        periodicity
        quoteProductId
        serviceAmount
        servicePercent
        serviceTypeCode
        serviceTypeName
        serviceTypeId
        calcTypeId
      }
      priceCard {
        priceCardId
        priceCardName
        statusId
        priceCardVersion
        priceCardGuid
        matrixLines {
          id
          tenorFrom
          tenorTo
          purchasePriceFrom
          purchasePriceTo
          customerInterestPercent
          subsidyPercent
          residualValuePercent
          interestUseSlider
          enableDealerCommisionPreview
          enableDealerSubsidyPreview
          parameterForSharing
          residualValueVisible
          flatRate
        }
      }
      productSchedule {
        columnDefinitions {
          columnCaption
          columnName
          displayFormat
          displayOrder
          isService
          scheduleTypeDetailId
          systemTypeName
        }
        scheduleLines {
          values {
            columnCaption
            columnName
            displayFormat
            isDisplayed
            systemTypeName
            value
          }
        }
      }
    }
  }
  ${Fragments.quoteProduct}
`;

export const REMOVE_PRODUCT = gql`
  mutation removeProduct($quoteId: Int!, $quoteProductId: Int!) {
    removeProduct(quoteId: $quoteId, quoteProductId: $quoteProductId)
  }
`;

export const CLONE_PRODUCT = gql`
  mutation cloneProduct($quoteProductId: Int!) {
    cloneProduct(quoteProductId: $quoteProductId)
  }
`;

export const SEND_PRODUCTS_ON_EMAIL = gql`
  mutation sendProductsOnEmail($quoteId: Int!, $email: String!, $products: [Int]!) {
    sendProductsOnEmail(quoteId: $quoteId, email: $email, products: $products)
  }
`;

export const COMPUTE_SCHEDULE = gql`
  mutation computeSchedule($quoteId: Int!, $quoteProductId: Int!, $addInsurance: Boolean) {
    computeSchedule(quoteId: $quoteId, quoteProductId: $quoteProductId, addInsurance: $addInsurance) {
      ...quoteProduct
      productSchedule {
        columnDefinitions {
          columnCaption
          columnName
          displayFormat
          displayOrder
          isService
          scheduleTypeDetailId
          systemTypeName
        }
        scheduleLines {
          values {
            columnCaption
            columnName
            displayFormat
            isDisplayed
            systemTypeName
            value
          }
        }
      }
    }
  }
  ${Fragments.quoteProduct}
`;

export const RECOVER_PRODUCT = gql`
  mutation recoverProduct($quoteProductId: Int!) {
    recoverProduct(quoteProductId: $quoteProductId)
  }
`;

export const SAVE_INSURANCES = gql`
  mutation saveInsurances($input: InsuranceInput!) {
    saveInsurances(input: $input)
  }
`;
